export function formatDate(date): string {
    return date ? new Date(date).toLocaleDateString('hu-HU') : null;
}
